import { TOKENS_PATH } from 'modules/tokens/constants'
import { getObjectUtil } from 'packages/src'

function getTokenSelector () {
  return state => {
    return getObjectUtil(state, TOKENS_PATH.DATA)[getObjectUtil(state, TOKENS_PATH.NEW)]
  }
}

export {
  getTokenSelector
}
